import { initAmplitude } from "./amplitude";

initAmplitude();
